<!--
 * @author: JJ
 * @since: 2024-10-08
 * Checkout.vue
-->
<template>
    <div class="container">
        <Header/>
        <div class="top_nav">
            <div class="w1400 flex-box ptb10">
                <img src="../../assets/static/images/jj_logo_new.png" @click="toIndex" class="logo" alt="">
                <div class="flex-grow-1 pl60">
                    <div class="pl60 top_title fs18">收银台</div>
                </div>
            </div>
        </div>
        <div class="w1400 mt25 fs14 cursor"><span class="col90">当前位置：</span>
        <router-link to="/" class="col04">首页 /</router-link>
        <!-- <router-link to="/Cart" class="col04">采购车 /</router-link> -->
        <span class="col04"> 结算 /</span><span class="now_page"> 收银台</span></div>
        <div class="mt15 col90 fs14 w1400">正在使用微信支付，交易将在<span class="zprice1">{{auto_close}}</span>分钟后取消，请及时付款！</div>
        <div class="pay_box w1400">
            <template v-if="orderinfo.payState == 'paying'">
                <div class="pt20 pl30 flex-box" v-if="orderinfo.payment === 'wechat'">
                    <img src="../../assets/static/icon/jj_wepay.png" class="ico40" alt="">
                    <div class="pl15 col04 fs16 fwb">微信支付</div>
                </div>
                <div class="flex-box flex-center flex-col mt92 w1006" >
                    <div class="fs16 col04">扫一扫付款（元）</div>
                    <div class="coleb fs22 fwb">{{total_amount}}</div>
                    <img :src="qrocde_url" class="code" alt="">
                </div>
            </template>
            <div class="flex-box flex-center flex-col w1006 pt250" v-else-if="orderinfo.payState == 'success'">
                <div class="flex-box">
                    <img src="../../assets/static/icon/jj_wepay.png" class="ico64" alt="">
                    <div class="col00c pl25 fs16 fwb">支付成功</div>
                </div>
                <div class="mt40 fs14 col90">倒计时 <span class="zprice1">{{seconds}}</span> 秒后返回</div>
            </div>
            <div class="flex-box flex-center flex-col w1006 pt200" v-else-if="orderinfo.payState == 'fail'">
                <div class="flex-box">
                    <img src="../../assets/static/icon/jj_fail.png" class="ico62" alt="">
                    <div class="colf2 pl25 fs16 fwb">支付失败</div>
                </div>
                <div class="mt35 fs16 col90">所选银行卡余额不足，请重新支付。</div>
                <div class="btn_refresh cursor">重新支付</div>
            </div>
            <img src="../../assets/static/images/jj_pay.png" class="pay_bg" alt="">
        </div>
    </div>
</template>

<script setup>
import { ref,onMounted } from "vue"
import { useHead } from '@unhead/vue'
onMounted(() => {
    useHead({
        title: "收银台-小狮优选",
        meta: [
            { name: "description", content: "This is my page description" },
            { property: "og:title", content: "My Page Title" },
            { property: "og:description", content: "This is my page description" },
            { property: "og:url", content: "https://example.com/my-page" },
            { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
    })
})
const a = ref(0)
</script>
<script>
export default {
    data() {
        return {
           
			orderinfo: {},
			order:{corporate_account:[],pay_fee:0,pay_certificate:null},
			timeData: {},
			duigongPopStatus: false,
            createStatus: false,
			certificate: '',
            qrocde_url: '',
            total_amount: 0,
            pay_sn: '',
            timer: null,
            timers: null,
            seconds: 8,
            auto_close: 0
        }
    },
    created() {
        this.orderinfo = JSON.parse(decodeURIComponent(this.$route.query.data));
    },
    mounted() {
       this.pay();
       this.auto_close = this.$root.$data.config.app.auto_close; //关闭时间
    },
     beforeUnmount() {
        clearInterval(this.timer);
        clearInterval(this.timers);
    },
    methods: {
        toIndex(){
            this.$router.push('/')
        },
       //支付结果
         async pay() {
            let that = this;
            this.$api.PayOnline({order_sn: that.orderinfo.orderSN, payment: that.orderinfo.payment,showToast: true}).then(result=>{
                that.qrocde_url = result.data.pay_data.qrocde_url;
                that.total_amount = result.data.pay_data.total_amount;
                that.pay_sn = result.data.pay_data.pay_sn;
                that.checkPay();
            }).catch(err=>{
                that.timeDown()
            });
        },
        checkPay(){
            let that = this;
            that.timer = setInterval(function(){
                that.$api.PayCheck({pay_sn: that.pay_sn}).then(result=>{
                    if(result.data.payStatus){
                        clearInterval(that.timer);
                        that.orderinfo.payState = 'success';
                        that.timeDown()
                    }
                });
            },1500)
           
        },
        timeDown(){
            let that = this;
            that.timers = setInterval(function(){
                if(that.seconds == 0){
                    clearInterval(that.timers);
                    that.$router.replace("/Order");
                    return;
                }
                that.seconds--;
            },1000)
        },
        close(){
            this.show = false;
           this.$router.replace('/Order')
        }
    }
        
}
</script>
<style lang="less" scoped>
.top_nav {
    width: 100%;
    background: #f9f9f9;

    .logo {
        width: 170px;
        height: auto;
    }

    .pl60 {
        padding-left: 60px;
    }

    .top_title {
        padding-left: 60px;
        font-weight: 500;
        color: #040404;
        height: 100px;
        line-height: 100px;
        position: relative;

        &::before {
            content: '';
            width: 2px;
            height: 101px;
            background: rgba(98, 134, 171, 0.4);
            display: inline-block;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}

.col127 {
    color: #1275FF;
}

.cu {
    cursor: pointer;
}

.mt40 {
    margin-top: 40px;
}

.mt45 {
    margin-top: 45px;
}

.pay_box {
    margin-top: 15px;
   
    height: 766px;
    background: #FFFFFF;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    margin-bottom: 0.2rem;
}

.pt38 {
    padding-top: 38px;
}

.pl44 {
    padding-left: 44px;
}

.ico40 {
    width: 40px;
    height: auto;
}

.pay_bg {
    position: absolute;
    top: 0;
    right: 0;
    width: 394px;
    height: 766px;
}

.mt92 {
    margin-top: 92px;
}

.w1006 {
    width: 1006px;
}

.coleb {
    color: #EB3F25;
}

.code {
    width: 265px;
    height: auto;
    margin-top: 15px;
}

.ico64 {
    width: 64px;
    height: auto;
}

.ico62 {
    width: 62px;
    height: auto;
}

.pt250 {
    padding-top: 250px;
}

.col00c {
    color: #00C800;
}

.pt200 {
    padding-top: 200px;
}

.colf2 {
    color: #F20000;
}

.btn_refresh {
    width: 228px;
    height: 66px;
    line-height: 62px;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    color: #1275FF;
    border-radius: 6px;
    border: 2px solid #1275FF;
    margin-top: 25px;
}
</style>
